import React, { useEffect, useState } from "react";
import axios from "axios";

const AdminProfile = () => {
  const [admin, setAdmin] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({ name: "", position: "" });

  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAdmin(res.data);
      setFormData({ name: res.data.name || "", position: res.data.position || "" });
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");
    const res = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/api/admin/profile`,
      formData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setAdmin(res.data);
    setEditMode(false);
  };

  if (!admin) return <div>Loading...</div>;

  return (
    <div className="p-6 max-w-xl mx-auto bg-white rounded-xl shadow-md space-y-4" 
    >
      <h2 className="text-xl font-bold mb-2">Admin Profile</h2>
      {editMode ? (
        <>
          <input
            className="border rounded px-3 py-2 w-full mb-2"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Name"
          />
          <input
            className="border rounded px-3 py-2 w-full mb-2"
            name="position"
            value={formData.position}
            onChange={handleChange}
            placeholder="Position"
          />
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded"
            onClick={handleUpdate}
          >
            Save
          </button>
          <button
            className="ml-2 bg-gray-300 px-4 py-2 rounded"
            onClick={() => setEditMode(false)}
          >
            Cancel
          </button>
        </>
      ) : (
        <>
          <p><strong>Name:</strong> {admin.name}</p>
          <p><strong>Email:</strong> {admin.email}</p>
          <p><strong>Position:</strong> {admin.position}</p>
          <button
            className="mt-2 bg-blue-500 text-white px-4 py-2 rounded"
            onClick={() => setEditMode(true)}
          >
            Edit Profile
          </button>
        </>
      )}
    </div>
  );
};

export default AdminProfile;
